import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
export const OPEN_DEAL_REGISTRATION_SUMMARY_HANDLER = {
  topic: TOPIC_NAMES.OPEN_DEAL_REGISTRATION_SUMMARY,
  type: 'MODAL',
  componentLoader: () => import('../wrappers/DealRegistrationSummaryWrapper')
};